import { render } from "./InvestmentHistory.vue?vue&type=template&id=a01433d4&scoped=true"
import script from "./InvestmentHistory.vue?vue&type=script&lang=js"
export * from "./InvestmentHistory.vue?vue&type=script&lang=js"

import "./InvestmentHistory.vue?vue&type=style&index=0&id=a01433d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a01433d4"]])

export default __exports__